import { SITE_ENV_LABELS, SiteEnv } from '@pubstack/common/src/site'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Icon } from '~/components/Icon'
import { SITE_ENV_ICON_OUTLINE } from '~/components/siteEnvIcons'
import { Tooltip } from '~/components/Tooltip'

/** The media's environment, beside its name the way the ad unit list draws the ad format. */
export const SiteEnvIcon: FunctionComponent<{ env: SiteEnv }> = ({ env }) => (
  <Tooltip title={SITE_ENV_LABELS[env]}>
    <Icon name={SITE_ENV_ICON_OUTLINE[env]} width={'20px'} fill={Colors.SlateGrey} />
  </Tooltip>
)
